var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3639_9896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.412 3.488A11.822 11.822 0 0 0 11.997 0C5.44 0 .103 5.335.101 11.892c-.001 2.096.547 4.142 1.587 5.945L.001 24l6.306-1.654a11.889 11.889 0 0 0 5.685 1.448h.005c6.556 0 11.894-5.336 11.897-11.892a11.82 11.82 0 0 0-3.482-8.414zm-8.415 18.297h-.004a9.876 9.876 0 0 1-5.032-1.378l-.362-.214-3.742.981 1-3.647-.236-.374a9.858 9.858 0 0 1-1.512-5.26c.002-5.45 4.438-9.884 9.892-9.884a9.823 9.823 0 0 1 6.99 2.899 9.824 9.824 0 0 1 2.894 6.993c-.002 5.45-4.438 9.884-9.888 9.884z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.547 23.316l1.61-5.88A11.328 11.328 0 0 1 .643 11.76C.645 5.505 5.737.413 11.995.413a11.28 11.28 0 0 1 8.03 3.329 11.277 11.277 0 0 1 3.322 8.028c-.002 6.258-5.095 11.35-11.352 11.35h-.005c-1.9-.001-3.767-.478-5.425-1.382L.547 23.316z",
    fill: "url(#paint0_linear_3639_9896)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.057 6.843c-.22-.49-.451-.499-.66-.507-.172-.008-.368-.007-.564-.007a1.08 1.08 0 0 0-.783.367c-.27.294-1.029 1.005-1.029 2.45 0 1.446 1.053 2.843 1.2 3.04.147.196 2.033 3.257 5.02 4.435 2.481.979 2.986.784 3.525.735.539-.049 1.739-.71 1.984-1.397.244-.686.244-1.274.171-1.397-.073-.122-.27-.196-.563-.343-.294-.146-1.739-.857-2.008-.955-.27-.098-.465-.147-.661.147s-.759.955-.93 1.151c-.172.197-.343.221-.637.074-.294-.147-1.24-.457-2.363-1.458-.874-.779-1.463-1.74-1.635-2.035-.171-.294-.018-.453.13-.6.131-.131.293-.342.44-.514.147-.172.196-.294.294-.49.098-.196.049-.368-.025-.515-.073-.147-.644-1.6-.906-2.18z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.315 3.45A11.687 11.687 0 0 0 11.997.002C5.514.002.239 5.276.237 11.758c-.001 2.072.54 4.094 1.57 5.877l-1.67 6.092 6.235-1.635a11.75 11.75 0 0 0 5.62 1.431h.005c6.48 0 11.757-5.274 11.76-11.756a11.685 11.685 0 0 0-3.442-8.317zm-8.318 18.088h-.004a9.762 9.762 0 0 1-4.975-1.362l-.357-.212-3.7.97.988-3.606-.233-.37a9.746 9.746 0 0 1-1.494-5.2C2.224 6.372 6.61 1.989 12 1.989a9.711 9.711 0 0 1 6.91 2.866 9.712 9.712 0 0 1 2.86 6.913c-.001 5.387-4.386 9.77-9.773 9.77z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3639_9896",
    x1: 11.947,
    y1: 23.316,
    x2: 11.947,
    y2: 0.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3639_9896"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23.894v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.634102cd27e0c2cb8fda81821d219834.svg";
export { ForwardRef as ReactComponent };